import { HermesTokenResult, RefreshTokenExchangeResult } from '@kaligo/hermes';
import { createSelector } from '@ngrx/store';
import { AuthRenderState } from '@rd/types';
import { CoreState, getCoreState } from '../../../store/reducers';
import { AuthState } from '../reducers/auth.reducer';

const getAuthState = createSelector(
  getCoreState,
  (state: CoreState) => state.auth,
);

const getUser = (state: AuthState) => state.user;
const getTokenResult = (state: AuthState) => state.tokenResult;
const getHermesLoading = (state: AuthState) => state.hermesLoading;
const getIsLoggedIn = (state: AuthState) => state.isLoggedIn;
const getIsSessionCheckRunning = (state: AuthState) =>
  state.isSessionCheckRunning;
const getIsIdleCheckRunning = (state: AuthState) => state.isIdleCheckRunning;

export const getAuthUser = createSelector(getAuthState, getUser);

export const getAuthToken = createSelector(getAuthState, getTokenResult);

export const getIdToken = createSelector(
  getAuthToken,
  (state: HermesTokenResult | RefreshTokenExchangeResult | null) =>
    state?.idToken,
);

export const getAuthHermesLoading = createSelector(
  getAuthState,
  getHermesLoading,
);

export const getAuthIsLoggedIn = createSelector(getAuthState, getIsLoggedIn);

export const getAuthIsSessionCheckRunning = createSelector(
  getAuthState,
  getIsSessionCheckRunning,
);

export const getAuthIsIdleCheckRunning = createSelector(
  getAuthState,
  getIsIdleCheckRunning,
);

export const getAuthRenderState = createSelector(
  getAuthIsLoggedIn,
  (isLoggedIn: boolean | null): AuthRenderState => {
    // isLoggedIn can be null or false. null means its pristine, false means its not logged in.
    // Must show 'loading' when, even if we refresh tokens, we still show the loggedIn or loggedOut state.
    if (isLoggedIn === null) {
      return 'loading';
    }

    if (isLoggedIn) {
      return 'loggedIn';
    }
    return 'loggedOut';
  },
);

export const getUserPreferences = createSelector(
  getAuthToken,
  (
    state: HermesTokenResult | RefreshTokenExchangeResult | null,
  ):
    | HermesTokenResult['preferences']
    | RefreshTokenExchangeResult['preferences']
    | undefined => (state ? state.preferences : undefined),
);
